import { ReactNode, createContext, useContext } from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { SelectOption } from "shared/types/Select"
import { AttachmentType } from "shared/types/__generated__/graphql"

export interface FloorFormAttachmentsContextType {
  attachments: AttachmentType[] | null
  linkedAttachments: AttachmentType[] | null
  attachmentCategories: SelectOption<string>[] | null

  onUpload?: (
    file: FilePreview,
    category: string
  ) => Promise<ApiResponse<AttachmentType>> | void
}

const FloorFormAttachmentsContext =
  createContext<FloorFormAttachmentsContextType | null>(null)

export interface FloorFormAttachmentsProviderProps {
  value: FloorFormAttachmentsContextType
  children: ReactNode
}

export function FloorFormAttachmentsProvider({
  value,
  children
}: FloorFormAttachmentsProviderProps) {
  return (
    <FloorFormAttachmentsContext.Provider value={value}>
      {children}
    </FloorFormAttachmentsContext.Provider>
  )
}

export function useFloorFormAttachmentsContext() {
  const context = useContext(FloorFormAttachmentsContext)

  if (!context) {
    throw new Error(
      "useFloorFormAttachmentsContext must be used within FloorFormAttachmentsProvider"
    )
  }

  return context
}
